'use strict';
var collection = require('../internals/collection');
var collectionStrong = require('../internals/collection-strong');

// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/modules/es.map.js
// module id = xHaf
// module chunks = 0